// Amplitude configuration.
// Public project key is safe to live in the client bundle. When empty the
// analytics service becomes a no-op (handy for local dev if ever blanked).
export const AMPLITUDE_API_KEY = 'e53fc33b8f22376e12b98371db1cfb12';
